<template>
	<div class="container">
		<div class="main_box">
			<!--联系我们-->
			<fixed></fixed>
			<!--联系我们-->
			<!--导航-->
			<navbar :pageName="'Contract Manufacturing'"></navbar>
			<!--导航-->
			<!--块1-->
			<div class="block_1">
				<div class="tit"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					IVD Contract Manufacturing Solutions
				</div>
				<div class="txt"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="300"
					data-aos-offset="0"
					data-aos-once="true"
				>
					Put our decades of diagnostic development experience to use. CorDx provides in vitro diagnostics (IVD) contract manufacturingsolutions fofor healthcare companies of all sizes – from startups tolarge enterprises.
				</div>
				<div
					class="btn_box_more btn_box"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="500"
					data-aos-offset="0"
					data-aos-once="true"
					@click="goContact"
				>
					Work With CorDx<img src="../../assets/img_h5/组 32@2x.png" />
				</div>
				<div class="bg_box">
					<img src="../../assets/img_h5/蒙版组 19@2x.webp" />
				</div>
			</div>
			<!--块1-->
			<!--块2-->
			<div class="block_2">
				<div class="title"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					A Pathway for Bringing Your IVD Products to Life
				</div>
				<div class="text"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="200"
					data-aos-offset="0"
					data-aos-once="true"
				>
					When you choose CorDx to manufacture your IVD products, you get end-to-end diagnostic capabilities, a world-class supply chain, and fully compliant systems, all run by a global team of IVD experts ready to bring your diagnostic solutions to the market. Our team is well-versed in the latest IVD technology, allowing us to quickly produce a range of high-quality products fofor applications including:
				</div>
				<div
					class="text"
					style="line-height: 1.8;"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="300"
					data-aos-offset="0"
					data-aos-once="true"
				>
					● Respiratory Diseases<br />
					● Infectious Diseases<br />
					● Sexually Transmitted Diseases<br />
					● Fertility Monitoring<br />
					● Drugs of Abuse<br />
					● Cardiac Markers<br />
					● Tumor Markers<br />
					● Health TeTests<br />
					● Blood Glucose
				</div>
				<div class="btn_el"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="400"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="btn_box_more btn_box" @click="goContact">
						Work With CorDx<img src="../../assets/img_h5/组 32@2x.png" />
					</div>
				</div>
			</div>
			<!--块2-->
			<!--块4-->
			<div class="quality_box">
				<div class="block_4_main"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="title">Quality Certifications</div>
					<div class="list_box">
						<div class="list_el" style="background-color: #FBFBFE;">
							<img class="img" src="../../assets/files/MDSAP.webp" @click="openPdf(require('@/assets/files/MDSAP.webp'))" />
							<div class="tit_box">
								<div class="tit">MDSAP</div>
								<img class="icon" src="../../assets/files/icon_download.webp" @click="downPdf('https://cordx.com/files/MDSAP.pdf')" />
							</div>
						</div>
						<div class="list_el" style="background-color: #FBFEFC;">
							<img class="img" src="../../assets/files/ISO-13485-2016.webp" @click="openPdf(require('@/assets/files/ISO-13485-2016.webp'))" />
							<div class="tit_box">
								<div class="tit">ISO 13485:2016</div>
								<img class="icon" src="../../assets/files/icon_download.webp" @click="downPdf('https://cordx.com/files/ISO-13485-2016.pdf')" />
							</div>
						</div>
					</div>
				</div>
			</div>
			<!--块4-->
			<!--块3-->
			<div class="block_3">
				<div class="block_box"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="block_el" style="background-color: #FBFEFC;">
						<img src="../../assets/img/img@2x_副本.webp" />
						<div class="title">
							End-to-End IVD Development
						</div>
						<div class="text">
							Our flexible IVD manufacturing solutions cover each step of your product lifecycle. We cover everything including:
						</div>
						<div class="el_box">
							<div class="left">●</div>
							<div class="right">Product design and development</div>
						</div>
						<div class="el_box">
							<div class="left">●</div>
							<div class="right">DFMEA and DFM review prior to tool fabrication</div>
						</div>
						<div class="el_box">
							<div class="left">●</div>
							<div class="right">Low-cost prototyping and tooling for proof-of-concepts</div>
						</div>
						<div class="el_box">
							<div class="left">●</div>
							<div class="right">Design optimization</div>
						</div>
						<div class="el_box">
							<div class="left">●</div>
							<div class="right">Full-volume production</div>
						</div>
					</div>
					<div class="block_el" style="background-color: #FEFCFC;">
						<img src="../../assets/img/蒙版组 1@2x_副本2.webp" />
						<div class="title">
							Integrated Supply Chain​
						</div>
						<div class="text">
							CorDx owns its supply chain from bottom to top to ensure the world has access to affordable, user-friendly & precise diagnostics products offered at competitive pricing.<br />
							Integrated supply chain benefits include:
						</div>
						<div class="el_box">
							<div class="left">●</div>
							<div class="right">Quality Control​</div>
						</div>
						<div class="el_box">
							<div class="left">●</div>
							<div class="right">Accessibility</div>
						</div>
						<div class="el_box">
							<div class="left">●</div>
							<div class="right">Cost Savings​</div>
						</div>
						<div class="el_box">
							<div class="left">●</div>
							<div class="right">Flexibility</div>
						</div>
					</div>
					<div class="block_el" style="background-color: #F9FAFE;">
						<img src="../../assets/img/蒙版组 1@2x (1)_副本2.webp" />
						<div class="title">
							Quality Systems
						</div>
						<div class="text">
							CorDx maintains a steadfast focus on quality management systems for medical devices.
						</div>
						<div class="el_box">
							<div class="left">●</div>
							<div class="right">Global：<br />100% GMP compliant</div>
						</div>
						<div class="el_box">
							<div class="left">●</div>
							<div class="right">China:<br />ISO 13485:2016<br />ISO 9001:2015<br />Verified by TUV</div>
						</div>
						<div class="el_box">
							<div class="left">●</div>
							<div class="right">US:<br />ISO 13485:2016<br />Verified by TUV</div>
						</div>
					</div>
				</div>
				<div
					class="block_btn"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="btn_box_more btn_box" @click="goContact">
						Work With CorDx<img src="../../assets/img/组 32@2x.png" />
					</div>
				</div>
			</div>
			<!--块3-->
			<!--块4-->
			<div class="block_4">
				<div class="title"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					World-leading IVD Manufacturing Capacity
				</div>
				<div class="text"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="200"
					data-aos-offset="0"
					data-aos-once="true"
				>
					CorDx maintains a combined 3+ million square feet ofmanufacturing facilities worldwide. We work with the latestIVD technology, allowing us to quickly produce a range ofhigh-quality IVD products.
				</div>
				<img
					src="../../assets/contract-manufacturing/h5/block_1.webp"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="300"
					data-aos-offset="0"
					data-aos-once="true"
				/>
			</div>
			<!--块4-->
			<!--块5-->
			<div class="block_5">
				<div class="title"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					About CorDx
				</div>
				<div class="text"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="200"
					data-aos-offset="0"
					data-aos-once="true"
				>
					CorDx manufactures point-of-care and over-the-counter rapid diagnostic products across a variety of categories, including infectious disease, reproductive & sexual health, substance abuse, and other health and marker tests. With authorization for use in the US (FDA), Europe (CE Mark) and China (NMPA), CorDx tests are known for their comfofort, speed and accuracy.<br />
					Since 2006, CorDx has developed diagnostic products while establishing a solid supply chain foundation, allowing it to provide better quality, more affordable tests for distributors healthcare providers, and patients alike.
				</div>
				<img
					src="../../assets/contract-manufacturing/h5/block_2.webp"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="300"
					data-aos-offset="0"
					data-aos-once="true"
				/>
			</div>
			<!--块5-->
			<!--块6-->
			<div class="block_6">
				<div class="title"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					Let CorDx Manufacture Your Next IVD Breakthrough
				</div>
				<div class="text"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="200"
					data-aos-offset="0"
					data-aos-once="true"
				>
					We partner with organizations of all sizes to develop, manufacture, and distribute diagnostics that empower patients to improve their health. Work with CorDx to bring your IVD solutions to life.
				</div>
				<div class="block_btn"
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="300"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="btn_box_more btn_box" @click="goContact">
						Talk to CorDx<img src="../../assets/img/组 32@2x.png" />
					</div>
				</div>
			</div>
			<!--块6-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navbar from '@/component/nav.vue'  //导航组件
import footerBox from '@/component/footer.vue'  //版权组件
import fixed from '@/component/fixed.vue'  //联系我们悬浮
import download from 'downloadjs';
import { ImagePreview } from 'vant';
export default {
	components:{
		navbar,
		footerBox,
		fixed
	},
	data() {
		return {
			isLoading: true,  //界面loading
		}
	},
	created(){
		let that = this;
		window.scroll(0, 0);
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		goContact() {
			this.$router.push('/contact');
		},
		openPdf(value) {
			let that = this;
			ImagePreview([value]);
		},
		downPdf(value) {
			let that = this;
			download(value);
		}
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	height: auto;
	color: #000000;
	/*块4*/
	.quality_box{
		width: 100%;
		margin: 0 auto;
		padding: 24px 20px 0 20px;
		color: #000000;
		.list_box{
			padding-top: 0px;
			padding-bottom: 0;
			.list_el{
				width: 100%;
				text-align: center;
				margin-top: 30px;
				padding: 30px 20px;
				.tit_box{
					padding-top: 15px;
					.icon{
						display: inline-block;
						width: 18px;
						margin-left: 5px;
						position: relative;
						top: 3px;
					}
					.tit{
						display: inline-block;
						font-size: 20px;
						color: #000000;
					}
				}
				.img{
					width: 100%;
				}
			}
		}
		.title{
			font-size: 36px;
		}
	}
	//块6
	.block_6{
		padding: 60px 20px 70px 20px;
		background-color: transparent;
		background-image: linear-gradient(180deg,  #F1ECE6 20%, #FFFFFF 100%);
		.block_btn{
			text-align: center;
		}
		.text{
			padding: 20px 0 40px 0;
			font-size: 20px;
		}
		.title{
			font-size: 40px;
		}
	}
	//块5
	.block_5{
		padding: 70px 20px;
		img{
			width: 100%;
		}
		.text{
			padding: 20px 0 50px 0;
			font-size: 20px;
		}
		.title{
			font-size: 40px;
		}
	}
	//块4
	.block_4{
		padding: 60px 0;
		background-color: #F8FBFF;
		img{
			width: 100%;
		}
		.text{
			padding: 15px 20px 50px 20px;
			font-size: 20px;
		}
		.title{
			padding: 0 20px;
			font-size: 40px;
		}
	}
	//块3
	.block_3{
		padding: 70px 20px 70px 20px;
		.block_btn{
			text-align: center;
			.btn_box{
				margin-top: 20px;
			}
		}
		.block_box{
			.block_el{
				margin-bottom: 20px;
				padding: 15px 15px 30px 15px;
				.el_box{
					display: flex;
					padding: 2px 0;
					.right{
						flex: 1;
						padding-left: 8px;
						font-size: 18px;
					}
					.left{
						width: auto;
						font-size: 18px;
					}
				}
				.text{
					padding: 10px 0 20px 0;
					font-size: 18px;
				}
				.title{
					padding-top: 30px;
					font-size: 32px;
				}
				img{
					width: 100%;
				}
			}
		}
	}
	//块2
	.block_2{
		padding: 70px 20px 70px 20px;
		background-color: #F8FBFF;
		.btn_el{
			text-align: center;
			.btn_box{
				margin-top: 40px;
				background-color: #F8FBFF;
			}
		}
		.text{
			padding-top: 30px;
			font-size: 20px;
		}
		.title{
			font-size: 40px;
		}
	}
	/*块1*/
	.block_1{
		text-align: center;
		.bg_box{
			img{
				width: 100%;
			}
		}
		.btn_box{
			margin-top: 30px;
		}
		.txt{
			padding: 10px 20px 0 20px;
			font-size: 20px;
		}
		.tit{
			padding: 36px 20px 0 20px;
			font-size: 40px;
		}
	}
	/*按钮*/
	.btn_box_more{
		display: inline-block;
		padding: 1px 30px 0 30px;
		height: 42px;
		line-height: 42px;
		font-size: 20px;
		color: #0B318F;
		background: #FFFFFF;
		border-radius: 22px 22px 22px 22px;
		border: 1px solid #CBD6E2;
		text-align: center;
		cursor: pointer;
		img{
			width: 18px;
			position: relative;
			top: 10px;
			left: 10px;
			transition: all 0.3s;
		}
	}
}
</style>
